import React from 'react';
import PropTypes from 'prop-types';

const Accounts = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 4.85C12.4865 4.85 12.9622 4.99428 13.3667 5.26458C13.7713 5.53489 14.0866 5.91909 14.2727 6.3686C14.4589 6.81811 14.5077 7.31273 14.4127 7.78992C14.3178 8.26712 14.0835 8.70545 13.7395 9.04948C13.3955 9.39352 12.9571 9.62781 12.4799 9.72273C12.0027 9.81765 11.5081 9.76894 11.0586 9.58274C10.6091 9.39655 10.2249 9.08125 9.95459 8.6767C9.68428 8.27216 9.54 7.79654 9.54 7.31C9.54 6.65757 9.79918 6.03186 10.2605 5.57052C10.7219 5.10918 11.3476 4.85 12 4.85ZM12 15.4C15.48 15.4 19.15 17.11 19.15 17.86V19.15H4.85V17.86C4.85 17.11 8.52 15.4 12 15.4ZM12 2.63C11.072 2.63 10.1648 2.90532 9.39334 3.42111C8.62186 3.93689 8.02074 4.66996 7.66606 5.52753C7.31138 6.3851 7.21909 7.32862 7.40087 8.23866C7.58264 9.1487 8.03032 9.98436 8.68723 10.6399C9.34414 11.2954 10.1807 11.7413 11.0912 11.9211C12.0016 12.1009 12.9449 12.0066 13.8017 11.6501C14.6585 11.2936 15.3903 10.6909 15.9045 9.91834C16.4186 9.14576 16.692 8.23802 16.69 7.31C16.69 6.69457 16.5686 6.08519 16.3328 5.51673C16.097 4.94827 15.7514 4.43191 15.3157 3.9972C14.8801 3.56249 14.363 3.21797 13.794 2.98337C13.2251 2.74877 12.6154 2.62869 12 2.63ZM12 13.17C8.87 13.17 2.63 14.74 2.63 17.86V20.37C2.63 20.6352 2.73536 20.8896 2.9229 21.0771C3.11043 21.2646 3.36479 21.37 3.63 21.37H20.37C20.6352 21.37 20.8896 21.2646 21.0771 21.0771C21.2646 20.8896 21.37 20.6352 21.37 20.37V17.86C21.37 14.74 15.13 13.17 12 13.17Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Accounts.propTypes = {
  fill: PropTypes.string,
};

export default Accounts;
